import { render, staticRenderFns } from "./websiteCompany.vue?vue&type=template&id=64e90cad&scoped=true&"
import script from "./websiteCompany.vue?vue&type=script&lang=js&"
export * from "./websiteCompany.vue?vue&type=script&lang=js&"
import style0 from "./websiteCompany.vue?vue&type=style&index=0&id=64e90cad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e90cad",
  null
  
)

export default component.exports